import PropTypes from 'prop-types';

export const BrandDefaultProps = {
  brand: {},
};

export const BrandPropTypes = {
  brand: PropTypes.shape({
    logo: PropTypes.shape({
      path: PropTypes.string,
      alt: PropTypes.string,
      url: PropTypes.string,
    }),
    name: PropTypes.string,
  }),
};
